import { render, staticRenderFns } from "./TabelaResultadosOnus.vue?vue&type=template&id=adfc9d3e&scoped=true&"
import script from "./TabelaResultadosOnus.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosOnus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfc9d3e",
  null
  
)

export default component.exports